import Utils from '@/common/util.js';
import {
  getProviderLogo,
  getMiniProgramConfig
} from '@/common/open-miniprogram.js';

export default {
  computed: {
    providerLogo() {
      return getProviderLogo(this.value.providerCompanyNo);
    },
    isChargingTest() {
      return this.value.productCategoryCode == 'FL40000015';
    },
    isChargingCoupons() {
      return this.value.productCategoryCode == 'FL40000019';
    },
    isRightCard() {
      return this.value.productCategoryCode == 'FL40000001';
    }
  },
  methods: {
    handleToDetailClick() {
      this.$emit('toCouponsDetail');
    },
    goReport() {
      this.$emit('goReport', { ...this.value });
    },
    goToDetail() {
      const miniProgramKeyOb = {
        TELD: 'tld',
        XIAOJU: 'xjcd',
        STARCHARGE: 'xxcd',
        NWDD: 'nfdw',
        JSYKC: 'jsykc'
      };
      const miniProgramKey = miniProgramKeyOb[this.value.providerCompanyNo] || '';
      this.$emit('goToDetail', { ...this.value, companyNo: miniProgramKey });
    },
    handleToUseClick() {
      if (this.isCard) {
        this.setConfig(this.value.providerCompanyNo);
      } else if (this.isChargingTest) {
        // 电池检测
        const param = {
          productCategoryCode: this.value.productCategoryCode || '',
          rightRulePackageBindId: this.value.rightRulePackageBindId || '',
          rightName: this.value.rightName || ''
        };
        // 若未下单则跳转到检测下单页
        if (!this.value.orderNo) {
          wx.miniProgram.navigateTo({
            url: Utils.fillUrlWithParams('/pages/carbarn/select-car', param)
          });
        } else if (this.value.orderNo && this.value.isCheck == '0') {
          // 若已下单未检测则跳转订单去检测
          wx.miniProgram.navigateTo({
            url: `/pages/order/order-detail?orderNo=${this.value.orderNo}`
          });
        } else {
          // 兼容已下单已检测的多次使用券，跳转订单去检测
          wx.miniProgram.navigateTo({
            url: `/pages/order/order-detail?orderNo=${this.value.orderNo}`
          });
        }
        return;
      } else if (this.isChargingCoupons) {
        this.setConfig(this.value.providerCompanyNo);
      } else {
        this.goToDetail();
      }
    },
    setConfig(key) {
      const config = getMiniProgramConfig(key);
      this.config = config;
      this.openApp();
    },
    openApp() {
      const url = '/pages/extend/middle';
      wx.miniProgram.navigateTo({
        url: `${url}?miniProgramKey=${this.value.providerCompanyNo}`
      });
    },
    backPage() {
      wx.miniProgram.navigateBack({
        delta: 1
      });
    }
  }
};
